<template lang='pug'>
  div
    v-row(style="padding:10px 0px 0px 20px; margin-bottom:-40px")
      v-col(sm="6" md="6")
        v-row
          v-col(sm='5' md='3' style="margin-top:-15px")
            label Judul Izin Tamu
          v-col(sm='7' md='9' style="margin-top:-15px")
            label : {{dataVisitor.ipJudulPekerjaan}}  
          v-col(sm='5' md='3' style="margin-top:-15px")
            label Penanggung Jawab
          v-col(sm='7' md='9' style="margin-top:-15px")
            label : {{ipPenanggungJawab.name}} 
          v-col(sm='5' md='3' style="margin-top:-15px")
            label Departmen PIC
          v-col(sm='7' md='9' style="margin-top:-15px")
            label : {{dataRequestPermit.ipDeptDivisi}} 
          v-col(sm='5' md='3' style="margin-top:-15px")
            label Perusahaan PIC Tamu
          v-col(sm='7' md='9' style="margin-top:-15px")
            label : {{dataRequestPermit.ipPerusahaan}} 
          v-col(sm='5' md='3' style="margin-top:-15px")
            label Tujuan Kunjungan
          v-col(sm='7' md='9' style="margin-top:-15px")
            label : {{dataVisitor.ipTujuanKunjungan}}   
      v-col(sm="6" md="6")
        v-row
          v-col(sm='5' md='4' style="margin-top:-15px")
            label Tanggal Kunjungan
          v-col(sm='7' md='8' style="margin-top:-15px")
            label : {{dayjs(dataVisitor.ipTanggalKunjungan).format(dateFormat)}}  
          v-col(sm='5' md='4' style="margin-top:-15px")
            label Sampai Tanggal
          v-col(sm='7' md='8' style="margin-top:-15px")
            label : {{dayjs(dataVisitor.ipSelesaiKunjungan).format(dateFormat)}} 
          v-col(sm='5' md='4' style="margin-top:-15px")
            label Lokasi Kunjungan
          v-col(sm='7' md='8' style="margin-top:-15px")
            label : {{ipLocation.join(', ')}} 
          v-col(sm='5' md='4' style="margin-top:-15px")
            label Detail Lokasi
          v-col(sm='7' md='8' style="margin-top:-15px")
            label : {{dataVisitor.ipDetailLocation}} 
          v-col(sm='5' md='4' style="margin-top:-15px")
            label Klasifikasi
          v-col(sm='7' md='8' style="margin-top:-15px")
            label : {{dataVisitor.ipKlasifikasi}} 
    v-card-title
    DetailsVisitor( :dataVisitor="dataVisitor" :dialog="openDetail" :detailVisitor="detailVisitor" @closeModal="openDetail = false", :isAfterStartKunjungan="dayjs().isAfter(dataVisitor.ipTanggalKunjungan)" :isNotPic="!isPic()")
    EditVisitor( :dataVisitor="dataVisitor" :dialog="openEditVisitor" :detailVisitor="editDetailVisitor" @closeModal="openEditVisitor = false")
    InduksiView(:dialogType="dialogType" :dialog='dialog' :ip="ip" :dataRowVisitor='dataRowVisitor' @closeModal="dialog = false" :dataRequestPermit='dataRequestPermit' :approvalUser="dataUsers" title="Preview")
    v-snackbar(v-model="notifResendSnackbar") Notification resent.
    v-data-table(:headers='ip.headers' :must-sort="true" :sort-by="pagination.sortBy" :sort-desc="pagination.descending" :items='ip.items')                
      template(v-slot:item.status="{ item }")
        v-chip(label small :color="config.statusVisitor[item.status].color" style="width:80%;justify-content:space-evenly" text-color="black") {{ config.statusVisitor[item.status].name }}
      template(v-slot:item.actions="{ item }")
        v-btn(icon  small @click.stop="openDetailVisitor(item)") 
          v-icon(small color="blue" dark ) remove_red_eye
        //- v-btn(icon v-if="showEdit(item)" small @click.stop="editVisitor(item)" ) 
        //-   v-icon(small color="green" dark ) edit
        v-btn(icon  small v-if="item.inductionStatus == 7" @click.stop="previewInduksi(item)" ) 
          v-icon(small color="#FF06B7" dark ) mdi-file-document-outline
        v-btn(icon v-if="showResendNotif(item)" small @click.stop="resendNotif(dataVisitor.ipNo, item.id)" ) 
          v-icon(color="orange" dark ) mdi-email-sync
          //- v-if="item.status == 7"
</template>

<script>
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import DetailsVisitor from '../components/DetailsVisitor.vue';
import EditVisitor from '../components/EditVisitor.vue';
import InduksiView from '../components/InduksiView.vue';
import dayJS from "dayjs"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
export default {
  name: 'VisitorList',
  components: {
    DetailsVisitor,
    EditVisitor,
    InduksiView
  },
  props: {
    title: String,
    dialogType: String,
    ip: Object,
    dataRequestPermit:Object,
    ipLocation:Array,
    ipPenanggungJawab:Object,
    dataVisitor:Object
  },
  data() {
    return {
      openEditVisitor: false,
      editDetailVisitor: false,
      visitorLink: "",
      search: '',
      openDetail : false,
      notifResendSnackbar: false,
      dialog: false,
      expanded: [],
      detailVisitor:{},
      dataRowVisitor:{},
      formName: config.FormName,
      config: config.default,
      statusSelect :[],
      formSelect : [],
      pagination: {
        sortBy: ["ipNo"],
        descending: [true]
      },
      uploadBukti: false,
      docPelaporan: null,
      inputModal: {},

      judulTamu:""
    };
  },
  mounted() {

  },
  computed: {
    ...mapState(['dataUsers','API_URL','fetchDataQuestions', 'dateFormat', 'resendNotification']),
  },
  methods: {
    showEdit(item) {
      return item.status == 7 && (this.dataVisitor.ipStatus == 2 || this.dataVisitor.ipStatus == 4) && this.dayjs().isBefore(this.dataVisitor.ipTanggalKunjungan) && this.isPic()
    },
    showResendNotif(item) {
      let allowedStatus = (this.dataVisitor.ipStatus == 2 || this.dataVisitor.ipStatus == 4);
      if (this.dataVisitor.ipFromThird) allowedStatus = this.dataVisitor.ipStatus == 4;
      return (item.status == 16 || (item.status == 7 && item.inductionStatus == 16)) && allowedStatus && this.dayjs().isSameOrBefore(this.dataVisitor.ipTanggalKunjungan, "day") && this.isPic()
    },
    isPic() {
      return this.dataUsers.group_level.includes("PIC");
    },
    resendNotif(ipNo, visitorId) {
      this.$store.dispatch('resendNotification', {ipNo, visitorId});
      this.notifResendSnackbar = true;
    },
    dayjs(val = undefined) {
      dayJS.extend(isSameOrBefore);
      return dayJS(val);
    },
    formatDate: helper.formatDateOnly,
   openDetailVisitor(param){
    this.detailVisitor = param
    this.openDetail = true;
   },
   previewInduksi(param){
    this.dataRowVisitor = param
    this.dialog = true
   }
  },
   watch: {   
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>